import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TextField, JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-order-overview-cost',
  templateUrl: './order-overview-cost.component.html',
  styleUrls: ['./order-overview-cost.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    CommonUiUtilityComponentsModule,
    CSCaptureDirective,
  ],
})
export class OrderOverviewCostComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label?: TextField;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cost?: number;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hasDiscount = false;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() boldLabel = false;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip = '';
}
